"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
exports.__esModule = true;
exports["default"] = void 0;
exports.getOrganisation = getOrganisation;
exports.getOrganisations = getOrganisations;
exports.loadOrganisations = loadOrganisations;
var _objectSpread2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/objectSpread2"));
var _freeze = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/object/freeze"));
var _reduce = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/reduce"));
var _isArray = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/array/is-array"));
var _filter = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/filter"));
var _isInteger = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/number/is-integer"));
var _stringify = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/json/stringify"));
var _promise = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/promise"));
var _utils = require("./utils");
var _createMappedReducer;
/**
 * Any actions dealing with fetching data for / updating the 'orgs'
 * key in state, and their associated reducers, should be handled
 * in this file.
 */
var LOADING_ORGS = 'RW_OFFICE/ORGS/LOADING_ORGS';
var LOADED_ORGS = 'RW_OFFICE/ORGS/LOADED_ORGS';
var DEFAULT_ORG = (0, _freeze["default"])((0, _objectSpread2["default"])({}, _utils.DEFAULT_LOADABLE));
function reduceLoadingOrganisations(state, action) {
  var _context;
  var loading = (0, _reduce["default"])(_context = action.organisationIds).call(_context, function (result, organisationId) {
    // eslint-disable-next-line no-param-reassign
    result[organisationId] = result[organisationId] || (0, _objectSpread2["default"])((0, _objectSpread2["default"])({}, DEFAULT_ORG), {}, {
      loading: true,
      organisationId: organisationId
    });
    return result;
  }, {});
  return (0, _objectSpread2["default"])((0, _objectSpread2["default"])({}, state), loading);
}
function reduceLoadedOrganisations(state, action) {
  var _context2;
  var loaded = (0, _reduce["default"])(_context2 = action.organisationIds).call(_context2, function (result, organisationId) {
    var org = action.orgs[organisationId] || (0, _objectSpread2["default"])((0, _objectSpread2["default"])((0, _objectSpread2["default"])({}, DEFAULT_ORG), state[organisationId]), {}, {
      // Note: notFound if there was no error, otherwise we consider it an error
      notFound: !action.error
    });
    result[organisationId] = (0, _objectSpread2["default"])((0, _objectSpread2["default"])({}, org), {}, {
      loaded: true,
      loading: false,
      error: action.error
    });
    return result;
  }, {});
  return (0, _objectSpread2["default"])((0, _objectSpread2["default"])({}, state), loaded);
}
var reducer = (0, _utils.createMappedReducer)((_createMappedReducer = {}, _createMappedReducer[LOADING_ORGS] = reduceLoadingOrganisations, _createMappedReducer[LOADED_ORGS] = reduceLoadedOrganisations, _createMappedReducer), {});
var _default = exports["default"] = reducer;
/**
 * The only way that orgs data makes it into the state object
 * is through this synchronous action creator
 *
 * @param {Object} orgs - normalised orgs to add to state
 */
function loadingOrganisations(organisationIds) {
  return {
    type: LOADING_ORGS,
    organisationIds: organisationIds
  };
}
function loadedOrganisations(organisationIds, orgs, _temp) {
  var _ref = _temp === void 0 ? {} : _temp,
    _ref$error = _ref.error,
    error = _ref$error === void 0 ? false : _ref$error;
  return {
    type: LOADED_ORGS,
    organisationIds: organisationIds,
    orgs: orgs,
    error: error
  };
}
function getOrganisation(state, organisationId) {
  return state[organisationId] || (0, _objectSpread2["default"])((0, _objectSpread2["default"])({}, DEFAULT_ORG), {}, {
    organisationId: organisationId
  });
}
function getOrganisations(state, organisationIds) {
  if (organisationIds === void 0) {
    organisationIds = [];
  }
  var orgs = (0, _reduce["default"])(organisationIds).call(organisationIds, function (result, id) {
    result[id] = state[id] || (0, _objectSpread2["default"])((0, _objectSpread2["default"])({}, DEFAULT_ORG), {}, {
      organisationId: id
    });
    return result;
  }, {});
  var loaded = (0, _reduce["default"])(organisationIds).call(organisationIds, function (result, id) {
    return result && orgs[id].loaded;
  }, true);
  var loading = (0, _reduce["default"])(organisationIds).call(organisationIds, function (result, id) {
    return result && orgs[id].loading;
  }, false);
  var error = (0, _reduce["default"])(organisationIds).call(organisationIds, function (result, id) {
    return result || orgs[id].error;
  }, false);
  return {
    loaded: loaded,
    loading: loading,
    error: error,
    entities: orgs
  };
}

/**
 * Async thunk action creator to load organisation data. Only
 * organisations which are not already in the store will be loaded.
 *
 * @param {Function} getOrgs Method to load organisations.
 * @param {Array} ids The IDs of the organisation(s) to load.
 *
 * @return {Function} dispatchLoadOrganisations.
 */
function loadOrganisations(getOrgs, organisationIds) {
  if (organisationIds === void 0) {
    organisationIds = [];
  }
  if (!(0, _isArray["default"])(organisationIds)) {
    throw new Error('organisationIds must be an Array');
  }
  var invalids = (0, _filter["default"])(organisationIds).call(organisationIds, function (id) {
    return !(0, _isInteger["default"])(id);
  });
  if (invalids.length) {
    throw new Error("Attempting to load invalid organisationIds: " + (0, _stringify["default"])(organisationIds));
  }

  /**
   * @param {Function} store.dispatch.
   * @param {Function} store.getState.
   *
   * @return {Promise} should be used for error handling / composition
   */
  return function dispatchLoadOrganisations(dispatch, getState) {
    var _getState = getState(),
      orgs = _getState.orgs;
    var missingIds = (0, _utils.getMissingKeys)(organisationIds, orgs);
    if (!missingIds.length) {
      // No organisations to load
      return _promise["default"].resolve(getOrganisations(getState().orgs, organisationIds));
    }
    dispatch(loadingOrganisations(missingIds));
    return getOrgs({
      id: missingIds
    }).then(function (data) {
      var _context3;
      var mapped = (0, _reduce["default"])(_context3 = data.results).call(_context3, function (results, org) {
        results[org.organisationId] = org; // eslint-disable-line no-param-reassign
        return results;
      }, {});
      return dispatch(loadedOrganisations(missingIds, mapped));
    })["catch"](function (error) {
      return dispatch(loadedOrganisations(missingIds, {}, {
        error: error
      }));
    }).then(function () {
      return getOrganisations(getState().orgs, organisationIds);
    });
  };
}